module.exports = __webpack_public_path__ + "static/media/t12.7878ca2e.jpg";